import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, AlertTriangle, CheckCircle2, ChevronDown, ArrowRight } from "lucide-react";
import { CFO_INSIGHTS } from "@/data/financeData";

const InsightCard = ({ insight }) => {
  const [open, setOpen] = useState(false);
  const isAlert = insight.type === "alert";
  return (
    <div
      data-testid={`insight-${insight.id}`}
      className={`rounded-2xl border p-5 transition-colors duration-200 ${
        isAlert
          ? "border-rose-200/60 bg-rose-50/50"
          : "border-emerald-200/60 bg-emerald-50/50"
      }`}
    >
      <div className="flex items-start gap-3">
        <div
          className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ${
            isAlert ? "bg-rose-100 text-rose-600" : "bg-emerald-100 text-emerald-600"
          }`}
        >
          {isAlert ? <AlertTriangle className="h-4 w-4" /> : <CheckCircle2 className="h-4 w-4" />}
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-slate-900">{insight.title}</p>
          <p className="mt-1 text-sm leading-relaxed text-slate-600">{insight.text}</p>

          <AnimatePresence initial={false}>
            {open && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.25 }}
                className="overflow-hidden"
              >
                <p className="mt-3 rounded-lg bg-white/70 p-3 text-xs leading-relaxed text-slate-500">
                  {isAlert
                    ? "Recomendação do CFO IA: renegociar tabela do convênio ou incentivar pacotes particulares para equilibrar a margem. Simule cenários no painel de estratégia."
                    : "Detalhe do CFO IA: os recebíveis projetados somam R$ 106.600,00 nos próximos 45 dias contra R$ 82.000,00 de contas — folga confortável de 30%."}
                </p>
              </motion.div>
            )}
          </AnimatePresence>

          <button
            data-testid={`insight-cta-${insight.id}`}
            onClick={() => setOpen((o) => !o)}
            className={`mt-3 inline-flex items-center gap-1.5 text-xs font-semibold transition-colors ${
              isAlert ? "text-rose-700 hover:text-rose-800" : "text-emerald-700 hover:text-emerald-800"
            }`}
          >
            {insight.cta}
            {isAlert ? (
              <ArrowRight className="h-3.5 w-3.5" />
            ) : (
              <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export const CfoInsights = () => {
  return (
    <div className="rounded-2xl border border-slate-200/70 bg-slate-50/60 p-5 md:p-6">
      <div className="mb-4 flex items-center gap-2">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-600">
          <Sparkles className="h-4 w-4 text-white" />
        </div>
        <div>
          <p className="font-heading text-base font-bold text-slate-900">
            Insights do CFO de Bolso
          </p>
          <p className="text-xs text-slate-500">Análise estratégica em linguagem natural</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {CFO_INSIGHTS.map((i) => (
          <InsightCard key={i.id} insight={i} />
        ))}
      </div>
    </div>
  );
};
